// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'schemas'

/**
 * Schema Model Interface (auto-generated from Drizzle schema)
 */
export interface SchemaModel {
  id: string
  orgId: string
  workspaceId: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  name: string
  title: string
  description: string
  icon?: string
  category: string
  target: string
  fields: Record<string, unknown>[]
  titleField: string
  defaultSort?: Record<string, unknown>
  ownerPluginId: string
  builtIn: boolean
  version: number
  archived: boolean
  classLevelPermissions?: Record<string, unknown>
  encryptedFields?: Record<string, unknown>[]
  tenantId?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
      "id": {
          "type": "string",
          "maxLength": 100
      },
      "orgId": {
          "type": "string",
          "maxLength": 100
      },
      "workspaceId": {
          "type": "string",
          "maxLength": 100
      },
      "userId": {
          "type": "string",
          "maxLength": 100
      },
      "createdAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "updatedAt": {
          "type": "string",
          "maxLength": 200,
          "format": "date-time"
      },
      "metadata": {
          "type": "object"
      },
      "extended": {
          "type": "object"
      },
      "name": {
          "type": "string",
          "maxLength": 500
      },
      "title": {
          "type": "string",
          "maxLength": 500
      },
      "description": {
          "type": "string",
          "maxLength": 100000
      },
      "icon": {
          "type": "string",
          "maxLength": 50
      },
      "category": {
          "type": "string",
          "maxLength": 200
      },
      "target": {
          "type": "string",
          "maxLength": 20
      },
      "fields": {
          "type": "array",
          "items": {
              "type": "object"
          }
      },
      "titleField": {
          "type": "string",
          "maxLength": 200
      },
      "defaultSort": {
          "type": "object"
      },
      "ownerPluginId": {
          "type": "string",
          "maxLength": 100
      },
      "builtIn": {
          "type": "boolean"
      },
      "version": {
          "type": "integer",
          "minimum": 0,
          "maximum": 9999,
          "multipleOf": 1
      },
      "archived": {
          "type": "boolean"
      },
      "classLevelPermissions": {
          "type": "object"
      },
      "encryptedFields": {
          "type": "array",
          "items": {
              "type": "object"
          }
      },
      "tenantId": {
          "type": "string",
          "maxLength": 100
      }
  },
  required: [
      "id",
      "orgId",
      "createdAt",
      "updatedAt",
      "name",
      "title",
      "description",
      "category",
      "target",
      "fields",
      "titleField",
      "builtIn",
      "version",
      "archived",
      "workspaceId",
      "ownerPluginId"
  ],
  indexes: [
      [
          "orgId",
          "name"
      ],
      [
          "orgId",
          "category"
      ],
      [
          "orgId",
          "workspaceId",
          "createdAt"
      ],
      [
          "target",
          "orgId"
      ],
      [
          "orgId",
          "ownerPluginId"
      ]
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
